import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, Input, signal, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageCode } from '../../models/language-code';
import { LanguageSelectComponent } from '../language-select/language-select.component';

@Component({
    selector: 'apcam-language-fab-button',
    imports: [
        CdkOverlayOrigin,
        LanguageSelectComponent,
        MatButtonModule,
        MatIconModule,
        TranslatePipe,
    ],
    templateUrl: './language-select-fab-button.component.html',
    styleUrl: './language-select-fab-button.component.scss',
})
export class LanguageSelectFabButtonComponent {
    @Input()
    public languages: WritableSignal<LanguageCode[]> = signal([]);

    protected langSelectionOpen: boolean = false;

    protected openLangSelection(): void {
        this.langSelectionOpen = true;
    }
}
